import { TextInput, SelectInput } from 'react-admin';
import {
  ADS_ACTION_STATUSES,
  ADS_ACTION_NAMES,
  ADS_ACTION_ENTITY_TYPES
} from '../../../../../helpers/adsActionsConstants';

export const getAdsActionsFilters = () => [
  <TextInput
    source="q"
    label="ID, Entity ID, Reason, Proposed by, Account"
    alwaysOn
    sx={{ width: '400px' }}
  />,
  <SelectInput
    source="status"
    label="Status"
    choices={ADS_ACTION_STATUSES}
    alwaysOn
    className="input-width-md"
  />,
  <SelectInput
    source="action"
    label="Action"
    choices={ADS_ACTION_NAMES}
    className="input-width-md"
  />,
  <SelectInput
    source="entity_type"
    label="Entity Type"
    choices={ADS_ACTION_ENTITY_TYPES}
    className="input-width-md"
  />,
  <TextInput source="internal_account_id" label="Account ID" />
];
